import "./TaxiBooking.module.css";
import Header from "@/reusable_sections/Header";
import TaxiFoglalasHero from "./sections/TaxiFoglalasHero";
import ContactInfo from "./sections/ContactInfo";
import Software from "./sections/Software";
import Footer from "@/reusable_sections/Footer";
export default function TaxiBookingPage() {
  return <div>
      <Header />
      <TaxiFoglalasHero />
      <Software />
      <ContactInfo />
      <Footer />
    </div>;
}